var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_441_6242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000488281,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_441_6242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 29.2505C6.175 29.2505 5.46875 28.9567 4.88125 28.3692C4.29375 27.7817 4 27.0755 4 26.2505V12.7505C4 12.2755 4.10625 11.8255 4.31875 11.4005C4.53125 10.9755 4.825 10.6255 5.2 10.3505L14.2 3.60049C14.475 3.40049 14.7625 3.25049 15.0625 3.15049C15.3625 3.05049 15.675 3.00049 16 3.00049C16.325 3.00049 16.6375 3.05049 16.9375 3.15049C17.2375 3.25049 17.525 3.40049 17.8 3.60049L26.8 10.3505C27.175 10.6255 27.4688 10.9755 27.6813 11.4005C27.8938 11.8255 28 12.2755 28 12.7505V26.2505C28 27.0755 27.7063 27.7817 27.1188 28.3692C26.5312 28.9567 25.825 29.2505 25 29.2505H19V18.7505H13V29.2505H7Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.961d94dd4cf67b5785060857ee7344fb.svg";
export { ForwardRef as ReactComponent };